export const LOGIN_VALIDATE = "LOGIN_VALIDATE";
export const LOGIN_VALIDATE_RESULT = "LOGIN_VALIDATE_RESULT";

export const LOGIN_LOGIN = "LOGIN_LOGIN";
export const LOGIN_FACEBOOK = "LOGIN_FACEBOOK";
export const LOGIN_GOOGLE = "LOGIN_GOOGLE";
export const LOGIN_LOGIN_RESULT = "LOGIN_LOGIN_RESULT";